<script context='module'>

	/**
	 * @author M.G.
	 */

	import ScheduledMessagePicker from './ScheduledMessagePicker.svelte';
	import {External} from '../../../external';
	import {M} from '../../../external';

	let messagePicker;

	export async function showScheduledMessagesList(contact, channel, onSelect, onEmpty, onNoData) {

		if (!contact.subscribed) {
			External.Tools.showError(M.CONTACT_NOT_SUBSCRIBED);
			return;
		}

		let messages = await getScheduledMessages(contact.id, channel, () => {  //fetch the data before opening the popup to avoid the lag between opening the popup and fetching/rendering the list
			onNoData();
		});

		if (messages) {
			External.Tools.showWindow({
				withDarkBackground: true,
				showCloseButton: false,
				noNav: true,
				noTitle: true,
				width: 500,
				action: {
					onShow: (popup, context) => {
						messagePicker = new ScheduledMessagePicker({
							target: popup.getContentArea(),
							props: {
								contact: contact,
								channel: channel,
								messages: messages,
								popup: popup,
								onSelect: (msg) => {
									if (onSelect(msg)) {
										popup.close();
									}
								},
								onEmpty: onEmpty
							}
						});
					}
				}
			});
		}
	}

</script>

<script>

	import {getAttachmentName} from "./common";

	export let contact, channel, messages, popup, onSelect, onEmpty;
	let moreBtns = [];

	function getScheduledMessages(contactId, channel, onNoData) {   //require the contactId and channel because we call this function before the component is mounted, a bit dirty...
		return new Promise((resolve) => {
			External.Tools.makeWebsiteRequest({
				action: 'getScheduledMessages',
				data: {
					contactId: contactId,
					channel: channel
				},

				onOk: (resp) => {
					if (resp.data?.length) {
						let dateFormat = External.WebsiteSettings.getDateFormat();
						let use24HrFormat = dateFormat === 'uk';

						resp.data.forEach((message) => {
							message.sendTime = new Date(message.sendTime);
							message.sendTime.formattedTime = External.Tools.dateToStr(message.sendTime, dateFormat) + ' ' + External.Tools.timeToString(message.sendTime, use24HrFormat);
						});
						resolve(resp.data);
					} else {
						onNoData();
					}
				}
			});
		});
	}

	async function sendTest(message) {
		External.Tools.prompt(M.SEND_TEST_MESSAGE, M.CONFIRM_SEND_TEST_MESSAGE_DESC, () => {
			External.Tools.makeWebsiteRequest({
				action: 'sendTestMessage',
				method: 'post',
				data: {
					message: JSON.stringify(message),
					channel: message.channel,
				},
				onOk: () => {
					External.Tools.showAutohideMessage(5, M.TEST_MESSAGE_SENT);
				}
			});
		});
	}

	function deleteScheduledMessage(message) {
		External.Tools.prompt(M.DELETE_EMAIL, M.DELETE_MESSAGE_DESC, () => {
			External.Tools.makeWebsiteRequest({
				action: 'deleteScheduledMessage',
				data: {
					contactId: message.contactId,
					messageId: message.id,
					channel: message.channel
				},
				onOk: async (resp) => {
					messages = await getScheduledMessages(contact.id, channel, () => {
						popup.close();
						if (onEmpty) {
							onEmpty();
						}
					});
				}
			});
		});
	}

	const MORE_OPTIONS = [
		{text: M.SEND_TEST_MESSAGE, icon: 'fa-at', tag: 'test'},
		{text: M.DELETE, icon: 'fa-trash', tag: 'delete'}
	];

	function showMoreOptions(moreButton, message) {
		let target = External.$(moreButton);

		External.Tools.showTooltipOptions(target, MORE_OPTIONS, async (target, idx, text, tag) => {
			if (tag === 'delete') {
				deleteScheduledMessage(message);
			} else if (tag === 'test') {
				await sendTest(message);
			}
		});
	}

	async function refreshList() {
		messages = await getScheduledMessages(contact.id, channel, () => {
			popup.close();
		});
	}

</script>

<div class='switch-popup-wrapper full-size flex flex-col cpanel-prompt-dialog' style='height: 70vh;'>
	<div class='cpanel-popup-title ui-draggable-handle' style='padding: 0px'>
		<a class='close-btn close-popup'><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg></a>
		<h2 class='col20 ta-center flex-none ui-draggable-handle'>{M.SCHEDULED_MESSAGES}</h2>
	</div>
	<div class='switch-popup-body-wrapper col20 flex-1 flex flex-col' style='padding: 0px;'>
		<div class='col20 f-left' style='box-sizing: border-box; padding: 0px 40px;'>
			{#key messages} <!-- renders more smoothly by re-rendering the entire container -->
				<div class='col20 f-left mt-15'>
					{#each messages as message, i}
						<div class='col20 f-left funnel-inner-wrapper funnel-item-view' on:click={() => onSelect(message)}>
							<div class='col20 f-left funnels-wrapper vertical-flex'>
								<div class='funnel-list-stats blue'>
									{#if message.channel === External.CRM_MESSAGE_CHANNEL.SMS}
										<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368" class="">
											<path
												d="M320-520q17 0 28.5-11.5T360-560q0-17-11.5-28.5T320-600q-17 0-28.5 11.5T280-560q0 17 11.5 28.5T320-520Zm160 0q17 0 28.5-11.5T520-560q0-17-11.5-28.5T480-600q-17 0-28.5 11.5T440-560q0 17 11.5 28.5T480-520Zm160 0q17 0 28.5-11.5T680-560q0-17-11.5-28.5T640-600q-17 0-28.5 11.5T600-560q0 17 11.5 28.5T640-520ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z"></path>
										</svg>
									{:else if message.channel === External.CRM_MESSAGE_CHANNEL.WHATSAPP}
										<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 124 124" viewBox="0 0 124 124" id="whatsapp">
											<path fill-rule="evenodd"
														d="M64,15.8c-25.5,0-46.2,20.7-46.2,46.2c0,9,2.5,17.6,7.4,25.1l-7,15.5 c-0.6,1.4-0.4,3.1,0.6,4.3c0.8,0.9,1.9,1.4,3.1,1.4c0.4,0,0.7,0,1.1-0.1l19.4-5.3c6.7,3.6,14.2,5.5,21.8,5.5 c25.5,0,46.2-20.7,46.2-46.2C110.2,36.5,89.5,15.8,64,15.8z M64,100.2c-6.8,0-13.4-1.8-19.2-5.2c-0.6-0.4-1.3-0.6-2-0.6 c-0.4,0-0.7,0-1.1,0.1L29,98l4.4-9.7c0.6-1.3,0.4-2.9-0.4-4c-4.7-6.5-7.2-14.2-7.2-22.3C25.8,41,43,23.8,64,23.8 c21,0,38.2,17.1,38.2,38.2C102.2,83,85.1,100.2,64,100.2z"
														clip-rule="evenodd"></path>
											<path fill-rule="evenodd"
														d="M81.8,68.9c-1.9-1.2-4.5-2.5-6.7-1.5c-1.7,0.7-2.9,3.5-4,4.9c-0.6,0.7-1.3,0.8-2.2,0.5 c-6.6-2.6-11.6-7-15.2-13c-0.6-0.9-0.5-1.7,0.2-2.6c1.1-1.3,2.5-2.8,2.8-4.5c0.3-1.7-0.5-3.8-1.2-5.3c-0.9-2-1.9-4.8-3.9-5.9 c-1.8-1-4.2-0.5-5.8,0.9c-2.8,2.3-4.2,5.9-4.1,9.4c0,1,0.1,2,0.4,3c0.6,2.3,1.6,4.5,2.9,6.6c0.9,1.6,1.9,3.1,3,4.5 c3.5,4.8,7.9,8.9,12.9,12c2.5,1.5,5.3,2.9,8.1,3.8c3.2,1,6,2.1,9.4,1.5c3.6-0.7,7.1-2.9,8.5-6.3c0.4-1,0.6-2.2,0.4-3.2 C86.6,71.3,83.6,70,81.8,68.9z"
														clip-rule="evenodd"></path>
										</svg>
									{:else if message.channel === External.CRM_MESSAGE_CHANNEL.VOICE}
										<svg class="mr-15" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
											<path
												d="M240-520h60v-80h-60v80Zm100 80h60v-240h-60v240Zm110 80h60v-400h-60v400Zm110-80h60v-240h-60v240Zm100-80h60v-80h-60v80ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z"></path>
										</svg>
									{/if}
								</div>
								<div class='funnel-inner-texts'>
									<h4 class='col20 f-left ellipsis' style='width: 88%;'>
										{#if message.attachments?.length && !message.body.length}
											{getAttachmentName(message.attachments[0])}
										{:else}
											{message.body}
										{/if}
									</h4>
									<span class='col20 f-left mt-10'>
                    <i class='fa fa-circle-arrow-right mr-5'/>{message.sendTime.formattedTime}
										{#if message.attachments?.length}
                      &nbsp;&nbsp;<i class='fa fa-solid fa-paperclip'/>
                    {/if}
                  </span>
								</div>
								<div class='funnel-controls' style='display: inline'>
									<a target='_blank' class='more-options button-tooltip' data-tooltip='{M.MORE_OPTIONS}'
										 bind:this={moreBtns[i]} on:click|stopPropagation={() => showMoreOptions(moreBtns[i], message)}/>
								</div>
							</div>
						</div>
					{/each}
				</div>
			{/key}
		</div>
	</div>
</div>
